var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"manifest-app p-page__section theme--light--alt mds",attrs:{"data-test":"main-holder","id":"main"}},[_c('url-migration-notification'),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }